// extracted by mini-css-extract-plugin
module.exports = {"moreWrp":"moreOptions_moreWrp__2zvTZ","optionWrp":"moreOptions_optionWrp__Qd7wW","opt":"moreOptions_opt__1VDXl","danger":"moreOptions_danger__2EHXL"};